<template>
  <div>
    <el-row style="margin-top:10px">
      <el-col :span="22">
        <el-form ref="searchForm" v-model="searchForm" :inline="true">
          <el-form-item label="商品名称：">
            <el-input size="medium" v-model="searchForm.productName" onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,'')">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" style="margin-left:20px" @click="handleSearch" :loading="loading">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border stripe :data="tableData">
          <el-table-column type="index" width="80" label="序号"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="SUPPLIER_PRICE" label="价格"></el-table-column>
          <el-table-column v-if="this.prevUrl === '/purchaseQuotation'" prop="SUBMIT_PRICE" label="报价">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="height:100px">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalNum" style="float:right;height:100px"></el-pagination>
    </el-row>
  </div>
</template>
<script>
import { queryDetailQuote, querySupplierChainDetailQuote } from 'api/quote';

export default {
  data() {
    return {
      loading: false,
      searchForm: {
        productName: '',
        productCode: '',
      },
      addForm: {},
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalNum: 0,
      prevUrl: '',
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.prevUrl = sessionStorage.getItem('prevUrl');
    console.log(this.prevUrl);
  },
  mounted() {
    this.defaultQuery();
  },
  methods: {
    defaultQuery() {
      if (this.prevUrl === '/quote') {
        const params = {
          CUSTOMER_ID: sessionStorage.getItem('view_ID'),
          CUSTOMER_TYPE: sessionStorage.getItem('customerType'),
          PAGEINDEX: this.currentPage - 1,
          PAGESIZE: this.pageSize,
        };
        if (this.searchForm.productName) {
          params.PRODUCT_NAME = this.searchForm.productName;
        }
        queryDetailQuote(params).then((result) => {
          console.log(result);
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.totalNum = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.totalNum = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loading = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loading = false;
        });
        this.loading = true;
      } else {
        const params = {
          SUPPLIER_ID: sessionStorage.getItem('supplierId'),
          PAGEINDEX: this.currentPage - 1,
          PAGESIZE: this.pageSize,
        };
        if (this.searchForm.productName) {
          params.PRODUCT_NAME = this.searchForm.productName;
        }
        querySupplierChainDetailQuote(params).then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.totalNum = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.totalNum = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loading = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loading = false;
        });
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.defaultQuery();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.defaultQuery();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/viewPrice.vue